/**
 * The Notifications tab: three cards, three different things.
 *
 * They are separate on purpose rather than merged into one grid, because they
 * are keyed differently and merging them would imply a relationship that is not
 * there. The first is per USER (which of Husly's own notifications you want),
 * the second is per CLIENT (what the CRM sends to a company you are the contact
 * for), and the third is per DEVICE (whether this browser can receive push at
 * all).
 */
import { AccountMatrixCard } from "./AccountMatrixCard";
import { ClientMatrixCard } from "./ClientMatrixCard";
import { PushDevicesCard } from "./PushDevicesCard";

export function NotificationsSection() {
  return (
    <div className="space-y-6">
      <AccountMatrixCard />
      <PushDevicesCard />
      <ClientMatrixCard />
    </div>
  );
}
